import React from 'react';
import { Row, Col } from 'react-bootstrap';
import ChartSkeleton from './ChartSkeleton';

/**
 * DashboardPlotSkeleton
 *
 * Skeleton for the DashboardPlot component that matches the layout:
 * - Session Overview chart (left side - 8/12 width)
 * - Sessions Insight gauge chart (right side - 4/12 width)
 */
const DashboardPlotSkeleton = () => {
  return (
    <Row className="mt-2 ms-1 w-100">
      {/* Session Overview Chart - Left side */}
      <Col lg={8} className="mb-3">
        <div className="pt-1 pe-0">
          <ChartSkeleton
            titleWidth="40%"
            chartHeight={320}
            showControls={true}
            chartType="rectangular"
          />
        </div>
      </Col>

      {/* Sessions Insight Gauge Chart - Right side */}
      <Col lg={4} className="mb-3">
        <div className="pt-1">
          <ChartSkeleton
            titleWidth="50%"
            chartHeight={200}
            showLegend={true}
            chartType="circular"
          />
        </div>
      </Col>
    </Row>
  );
};

export default DashboardPlotSkeleton;
